import { VipLevel } from "@/types/vip";

/**
 * VIP 功能权限配置唯一来源。
 *
 * 查看类能力已恢复为白银会员及以上可用：
 * - holder-relation-analysis
 * - internal-transfer-records
 * - lp-records
 */
export const VIP_FEATURES = {
	// 白银会员及以上可查看
	"holder-relation-analysis": [
		VipLevel.SILVER,
		VipLevel.LEVEL_1,
		VipLevel.LEVEL_2,
	],
	// 白银会员及以上可查看
	"internal-transfer-records": [
		VipLevel.SILVER,
		VipLevel.LEVEL_1,
		VipLevel.LEVEL_2,
	],
	// 白银会员及以上可查看
	"lp-records": [
		VipLevel.SILVER,
		VipLevel.LEVEL_1,
		VipLevel.LEVEL_2,
	],
	"price-alerts": [VipLevel.SILVER, VipLevel.LEVEL_1, VipLevel.LEVEL_2],
	"single-transfer": [VipLevel.SILVER, VipLevel.LEVEL_1, VipLevel.LEVEL_2],

	"flash-trading": [VipLevel.LEVEL_1, VipLevel.LEVEL_2],
	"batch-airdrop": [VipLevel.LEVEL_1, VipLevel.LEVEL_2],
	"rune-bridge-btc": [VipLevel.LEVEL_1, VipLevel.LEVEL_2],
	"frontrunner-real": [VipLevel.LEVEL_1, VipLevel.LEVEL_2],

	"limit-orders": [VipLevel.LEVEL_1, VipLevel.LEVEL_2],
	"tp-sl": [VipLevel.LEVEL_1, VipLevel.LEVEL_2],
	"advanced-charts": [VipLevel.LEVEL_1, VipLevel.LEVEL_2],
	"bot-generation": [VipLevel.LEVEL_1, VipLevel.LEVEL_2],
	"priority-execution": [VipLevel.LEVEL_1, VipLevel.LEVEL_2],
	"custom-alerts": [VipLevel.LEVEL_1, VipLevel.LEVEL_2],
} as const;

export type VipFeature = keyof typeof VIP_FEATURES;
